import { BillingServiceService } from 'cms-typescript-sdk/unistack/services';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DigitaloceanAccount } from 'cms-typescript-sdk/digitalocean/models';
import { AccountsServiceService } from 'cms-typescript-sdk/digitalocean/services';
import { BehaviorSubject, Observable } from 'rxjs';

import { TokenService } from './token.service';

export interface AbacRoleProto {
  name: string;
  entitlements: string[];
}

@Injectable({
  providedIn: 'root'
})
export class UserPrincipalService {

  private _authorised = false;
  // TODO: change to subject and emit values. NOW it's mock
  private _billingUpdateEvt$ = new BehaviorSubject(Math.round(Math.random() * 10000));

  private _userDetails: DigitaloceanAccount = {
    email: '',
    uuid: '',
  };

  /* TODO mock behind
   private _balance: Observable<number> = this.billingService.BillingBalance(this.userId)
   .pipe(
   repeatWhen(() => this._billingUpdateEvt$),
   tap(() => console.log('Request balance')),
   pluck('balance'),
   pluck('money')
   );
   */

  private _balance: Observable<number> = this._billingUpdateEvt$;

  public get userBalance(): Observable<number> {
    return this._balance;
  }

  public get userAccess(): AbacRoleProto[] {
    const fromStorage = localStorage.getItem('access');
    return fromStorage.length > 0 ? JSON.parse(atob(fromStorage)) : null;
  }

  public set userAccess(value: AbacRoleProto[]) {
    localStorage.setItem('access', btoa(JSON.stringify(value)));
  }

  // TODO remove DI later
  constructor(private account: AccountsServiceService,
              private token: TokenService,
              private translate: TranslateService,
              private billingService: BillingServiceService) {
    const currentLanguage = this.language;
    translate.addLangs(['en', 'ru']);
    translate.setDefaultLang('en');

    console.count('PrincipalService')

    translate.use(currentLanguage.match(/en|ru/) ? currentLanguage : 'en');
  }

  public get isAuthorised(): boolean {
    return this._authorised;
  }

  public getUserInfo(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.account.AccountsLookup()
        .subscribe(
          ({account}) => {
            this._userDetails.email = account.email;
            this._userDetails.uuid = account.uuid;
            this._authorised = true;
            resolve();
          },
          error => reject()
        );
    });
  }

  public get email(): string {
    return this._userDetails.email;
  }

  public get userId(): string {
    return this._userDetails.uuid;
  }

  public get language(): string {
    const fromStorage = localStorage.getItem('language');
    if (fromStorage !== null && fromStorage !== undefined) {
      return fromStorage;
    }
    if (this._userDetails.hasOwnProperty('locale')) {
      this.language = (this._userDetails as any).locale;
      return (this._userDetails as any).locale;
    }
    return this.translate.getBrowserLang();
  }

  public set language(lang: string) {
    localStorage.setItem('language', lang);
    this.translate.use(lang);
  }

  public abacParser(roles: string): AbacRoleProto[] {
    const result: AbacRoleProto[] = [];

    for (const raw of roles.split(' ')) {
      const attrs = raw.split(':');
      const findIdx = result.findIndex(el => el.name === attrs[0]);

      if (findIdx < 0) {
        result.push({name: attrs[0], entitlements: [attrs[1]]});
      } else {
        result[findIdx].entitlements.push(attrs[1]);
      }
    }

    // console.log(result);
    return result;
  }

  public logout(): Promise<void> {
    return this.token.revoke()
      .then(() => {
        window.localStorage.removeItem('access');
        this._authorised = false;
        return Promise.resolve();
      });
  }

  public fetchBalance() {
    // TODO: remove value in future
    this._billingUpdateEvt$.next(Math.round(Math.random() * 10000));
  }
}
